export const DATADOG_URL_MATCH_REGEXP = /https:\/\/(.*)?mcmakler.(com|de|at|fr)/g;
